function splitArrIntoNChunks(_arr, _size) {
  const chunked = [];

  for (let i = 0; i < _arr.length; i += _size) {
    chunked.push(_arr.slice(i, i + _size));
  }

  return chunked;
}

export { splitArrIntoNChunks };
